import React, { useState, useEffect, Fragment, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Box, Grid } from "@mui/material";
import { bindActionCreators } from "redux";
import { Button } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import { BackButton, Card, Loader, Toast } from "@egovernments/digit-ui-react-components";

import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import ReactToPrint from "react-to-print";
import useDepartmentSelector from "../../../TCPForms/hooks/useDepartmentSelector";
import useGetPurchasableFarData from "../../../TCPForms/formComponents/purchasableFAR/useGetPurchasableFarData";
import usePurchasableFarLogic from "./helpers/usePurchasableFarLogic";
import ButtonWrapper from "../../components/Button";
import SubStep1 from "./applicant-details/SubStep1";

import {
  MainWrapper,
  PortalWrapper,
  PrimaryTab,
  PrimaryTabs,
  PrimaryTabsWrapper,
  SideWrapper,
  StyledDivider,
  SubTab,
  SubTabs,
  SubTabsWrapper,
} from "../../components/StyledComponent";
import Sidebar from "../../components/Sidebar";
import HeaderContent from "../../components/Header";
import FormStrip from "../../components/FormStrip";
import SubStep3 from "./applicant-details/SubStep3";
import SubStep2 from "./applicant-details/SubStep2";
import SubStep4 from "./applicant-details/SubStep4";
import Checklist from "./checklist/Checklist";
import Documents from "./documents/Documents";
import Summary from "./summary/Summary";
import Map from "./location-map/Map";
import EditSummaryFAR from "./summary/EditSummaryFAR";
const PurchasableFAR2 = () => {
  //Mutable state variables below

  const {
    activeTab,
    setActiveTab,
    assignLTP,
    setAssignLTP,
    dispatch,
    t,
    id,
    history,
    initFormMTDocs,
    resetFormMTDocs,
    isUdFlow,
    applicationFlow,
    userUid,
    params,
    setParams,
    clearParams,
    isSessionCleared,
    isAppDataLoading,
    summaryRef,
    showToast,
    Modal,
    closeModal,
    handleTabChange,
    handleSubTabChange,
    applicationData,
    userInfo,
    tenantId,
    FAR_SB: SideBarLabelsFAR,
    FAR_PT: farPrimaryLabels,
    subActiveTab,
    setSubActiveTab,
    FAR_ST: subTabLabels,
    isUserEligible,
    setIsUserEligible,
    officesList,
    DepartmentSelector,
    closeToast,
    setShowToast,
    pFarList,
  } = usePurchasableFarLogic();

  console.log("destructuredData", applicationFlow, params);

  const applicationNumber = params?.applicationNo;
  const isAssignedLTP = userInfo?.name === params?.professionalInformation?.ltpName; // checks whether tagged LTP is filling the details
  const otherRoles = userInfo?.roles?.filter((item) => !["CITIZEN", "OWNER"].includes(item.code)); // all roles other than CITIZEN and OWNER
  // const isNotOwner = otherRoles?.length > 0; // FOR FAR only for now
  // console.log("isNotOwner", otherRoles, isNotOwner);
  const approvedLandUseData = useSelector((state) => state.approvedLandUseData);
  const approvedLayout = applicationData?.descriptionOfLand?.schemeType === "Scheme" ? "Yes" : "No";
  useEffect(() => {
    Digit.SessionStorage.set("FILE_NO");
    Digit.SessionStorage.set("OWNER_INFO");
  }, []);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "PURCHASABLE_FAR");
  console.log("updateAPI", updateApiCall);
  console.log("toastMessageFAR", showToast);
  const [isEditMode, setIsEditMode] = useState(false);
  const handlePreviewClick = () => {
    setIsEditMode(true);
  };
  const renderContent = () => {
    if (activeTab === 0) {
      switch (subActiveTab) {
        case 0:
          return (
            <SubStep1
              formData={params}
              handleSubTabChange={handleSubTabChange}
              t={t}
              userInfo={userInfo}
              dispatch={dispatch}
              isUserEligible={isUserEligible}
              setIsUserEligible={setIsUserEligible}
              isAssignedLTP={isAssignedLTP}
              officesList={officesList}
              applicationFlow={applicationFlow}
              tenantId={tenantId}
              initFormMTDocs={initFormMTDocs}
              showToast={showToast}
              setShowToast={setShowToast}
            />
          );
        case 1:
          return (
            <SubStep2
              formData={params}
              handleSubTabChange={handleSubTabChange}
              t={t}
              isAssignedLTP={isAssignedLTP}
              applicationData={approvedLandUseData?.applicationData}
              approvedLayout={approvedLayout}
            />
          );
        case 2:
          return (
            <SubStep3
              formData={params}
              handleSubTabChange={handleSubTabChange}
              t={t}
              applicationFlow={applicationFlow}
              isAssignedLTP={isAssignedLTP}
              applicationData={approvedLandUseData?.applicationData}
              approvedLayout={approvedLayout}
              pFarList={pFarList}
            />
          );
        case 3:
          return (
            <SubStep4
              formData={params}
              handleTabChange={handleTabChange}
              handleSubTabChange={handleSubTabChange}
              t={t}
              isAssignedLTP={isAssignedLTP}
              applicationData={approvedLandUseData?.applicationData}
            />
          );

        default:
          return null;
      }
    } else if (activeTab === 1) {
      return (
        <Documents
          formData={params}
          handleTabChange={handleTabChange}
          t={t}
          isApprovedLayout={approvedLayout}
          applicationData={approvedLandUseData?.applicationData}
        />
      );
    } else if (activeTab === 2) {
      return <Checklist formData={params} isUpdating={updateApiCall.isLoading} handleTabChange={handleTabChange} t={t} Modal={Modal} />;
    }
    // else if (activeTab === 3) {
    //   return (
    //     <Map formData={params} role={"CITIZEN"} handleTabChange={handleTabChange} t={t} applicationData={approvedLandUseData?.applicationData} />
    //   );
    // }
    else if (activeTab === 3 && applicationNumber) {
      return (
        <React.Fragment>
          {!isEditMode &&
            <div>
              <Summary formData={params} role={"CITIZEN"} handleTabChange={handleTabChange} ref={summaryRef} />
              <div
                style={{
                  margin: "20px",
                  padding: "12px 16px",
                  backgroundColor: "#fff3cd",
                  border: "1px solid #ffeeba",
                  borderRadius: "4px",
                  color: "#856404",
                  fontWeight: "500",
                }}
              >
                {t("FASTPAS.GLOBAL.ONCE.TEXT")}
              </div>
            </div>
          }
          {isEditMode && (
            <EditSummaryFAR formData={params} handleSubTabChange={handleSubTabChange} handleTabChange={handleTabChange} role={"CITIZEN"} />
          )}
          <div className="footerContainer">
            <div className="buttonWrapper">
              {!isEditMode && (
                <ReactToPrint
                  trigger={() => (
                    <ButtonWrapper variant="contained" color="secondary" size="medium" label="Print" sx={{ backgroundColor: "#7600bc" }} />
                  )}
                  content={() => summaryRef.current}
                />
              )}
              {!isEditMode ? (
                <ButtonWrapper
                  variant="contained"
                  color="error"
                  size="medium"
                  label="Preview"
                  sx={{ backgroundColor: "#CCC" }}
                  onClick={handlePreviewClick}
                />
              ) : (
                <ButtonWrapper
                  variant="contained"
                  color="error"
                  size="medium"
                  label="Save"
                  sx={{ backgroundColor: "#157CB3" }}
                  onClick={() => setIsEditMode(false)}
                />
              )}
              {!isEditMode && (
                <ButtonWrapper
                  variant="contained"
                  color="success"
                  size="medium"
                  label="Submit"
                  type="submit"
                  sx={{ backgroundColor: "#157CB3" }}
                  onClick={() => handleTabChange(4, params)}
                />
              )}
            </div>
          </div>
        </React.Fragment>
      );
    }
  };
  // const resetForm = () => {
  //   Digit?.SessionStorage.del("FORM_PURCHASABLE_FAR");
  //   // resetFormMTDocs();
  // };
  // const populateForm = () => {
  //   setParams(applicationData);
  //   if (applicationData?.documents?.length > 0) {
  //     initFormMTDocs(applicationData.documents);
  //   }
  // };
  // const handleFormMode = () => {
  //   if (id && applicationData) {
  //     console.log("insideIf ID");
  //     populateForm();
  //   } else if (!id && applicationData) {
  //     console.log("insideIf not ID");
  //     resetForm();
  //   }
  // };
  // useEffect(() => {
  //   console.log("Inside useEffect", applicationData);

  //   handleFormMode();
  // }, [id, applicationData]);

  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 2000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  if (isAppDataLoading || !applicationData) {
    return <Loader />;
  }
  if (applicationFlow === null) {
    return <DepartmentSelector />;
  }

  return (
    <React.Fragment>
      {/* <PortalWrapper> */}
      {/* <SideWrapper>
          <Sidebar Sidebarlabels={SideBarLabelsFAR} />
        </SideWrapper> */}

      <MainWrapper>
        <BackButton />
        {/* <HeaderContent applicationFlow={applicationFlow} /> */}
        <Box sx={{ boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", overflowY: "auto" }}>
          <FormStrip formName={t("Purchasable FAR")} />
          <PrimaryTabsWrapper>
            {/* Tabs Header */}
            <PrimaryTabs value={activeTab} onChange={(e, i) => setActiveTab(i)} aria-label="Tab Group" variant="scrollable" scrollButtons="auto">
              {farPrimaryLabels.map((item, index) => (
                <PrimaryTab key={`${item.text}.${index}`} label={item.text} />
              ))}
            </PrimaryTabs>
          </PrimaryTabsWrapper>
          {activeTab === 0 && (
            <SubTabsWrapper>
              <SubTabs
                value={subActiveTab}
                onChange={(e, i) => handleSubTabChange(i)}
                aria-label="Sub Tab Group"
                variant="scrollable"
                scrollButtons="auto"
              >
                {subTabLabels.map((tab, index) => (
                  <SubTab key={`${tab.text}.${index}`} label={tab.text} />
                ))}
              </SubTabs>
            </SubTabsWrapper>
          )}
          <StyledDivider />

          {renderContent()}
        </Box>
      </MainWrapper>
      {/* </PortalWrapper> */}
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDeleteBtn={true} />
      )}
    </React.Fragment>
  );
};

export default PurchasableFAR2;
